import Clarity from '@microsoft/clarity';
import { useEffect } from 'react';
import { setUserId, setUserProperties } from 'firebase/analytics';
import { useAnalytics } from './use-analytics';
import { useAppSelector } from './use-app-selector';

const useSetUserType = () => {
  const user = useAppSelector((state) => state.auth.user);
  let userType: string | undefined;
  if (user?.type) {
    userType = user?.type.toLowerCase();
  }
  const { analytics } = useAnalytics();

  useEffect(() => {
    if (user && analytics) {
      setUserId(analytics, user.id);
      if (user.salesCompanyCodeAndCustomerNumber) {
        setUserProperties(analytics, {
          dealer_customer: user.salesCompanyCodeAndCustomerNumber,
        });
      }
      if (userType) {
        setUserProperties(analytics, {
          user_type: userType,
        });
        Clarity.setTag('role', userType);
      }
    }
  }, [analytics, user, userType]);
};

export default useSetUserType;
